import { render, staticRenderFns } from "./NsCompany.vue?vue&type=template&id=59c4738d"
import script from "./NsCompany.vue?vue&type=script&lang=js"
export * from "./NsCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports